import type { FC, ReactNode } from 'react';
import { createContext, useContext } from 'react';

interface DashboardShellContextValue {
  isInsideShell: boolean;
}

const DashboardShellContext = createContext<DashboardShellContextValue>({
  isInsideShell: false,
});

export const useDashboardShell = (): DashboardShellContextValue =>
  useContext(DashboardShellContext);

interface DashboardShellProviderProps {
  children: ReactNode;
}

export const DashboardShellProvider: FC<DashboardShellProviderProps> = ({ children }) => (
  <DashboardShellContext.Provider value={{ isInsideShell: true }}>
    {children}
  </DashboardShellContext.Provider>
);
